import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'

console.log('Index.tsx loading...')
console.log('Current URL:', window.location.href)
console.log('Current pathname:', window.location.pathname)

import { ApplicationWidget } from './components/ApplicationWidget'

const root = document.getElementById('root')
console.log('Root element found:', root)

if (root) {
  ReactDOM.createRoot(root).render(
    <React.StrictMode>
      <ApplicationWidget />
    </React.StrictMode>
  )
  console.log('React app mounted')
} else {
  console.error('Root element not found!')
}
